import { useState, useEffect } from "react";
import Image from "next/image";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
export default function Gallery({ data = [] }) {
  const [index, setIndex] = useState(-1);
  const breakpoints = {
    1280: {
      slidesPerView: 2.6,
      spaceBetween: 30,
    },
    991: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 1.4,
      spaceBetween: 20,
    },
    325: {
      slidesPerView: 1.1,
      spaceBetween: 15,
    },
  };

  return (
    <div className="bg-[#E9E7DE] lg:py-20 py-10 z-[100] relative">
      <div className="flex flex-col w-full md:pl-8 pl-4">
        <Carousel
          slidesPerView={2.6}
          spaceBetween={30}
          loop={true}
          className="featureCarousel w-full my-8"
          breakpoints={breakpoints}
          navigation={false}
          showNavProject={false}
          showNavAbove={false}
          showNavGallery={true}
          // autoplay={{
          //   delay: 4500,
          //   disableOnInteraction: false,
          // }}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          }}
          pagination={false}

          // slidesOffsetAfter={20}
        >
          {data.map((post, key) => (
            <SwiperSlide key={"Post" + key} onClick={() => setIndex(key)}>
              <Post data={post} />
            </SwiperSlide>
          ))}
        </Carousel>
      </div>
      <Lightbox
        styles={{ root: { "--yarl__color_backdrop": "rgba(0, 0, 0, .9)" } }}
        slides={data?.map((node) => {
          return {
            src: node?.attributes?.url,
            //   description: row?.caption?.replace(
            //     /(<p[^>]+?>|<p>|<\/p>)/gim,
            //     ""
            //   ),
          };
        })}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        // enable optional lightbox plugins
        plugins={[Fullscreen, Slideshow, Thumbnails, Zoom, Captions]}
      />
    </div>
  );
}
const Post = ({ data }) => {
  const [loading, setLoading] = useState(true);
  const [currentSrc, updateSrc] = useState(
    data?.attributes?.formats?.thumbnail?.url ?? "/images/placeholder.svg"
  );

  useEffect(() => {
    if (!data?.attributes?.url) return;

    // Start loading the original image
    const imageToLoad = new window.Image();
    const originalSrc = data?.attributes?.url;

    imageToLoad.src = originalSrc;
    imageToLoad.onload = () => {
      // When the image is loaded, replace the src and set loading to false
      updateSrc(originalSrc);
      setLoading(false);
    };
  }, [data?.attributes?.url]);
  return (
    <div className="w-full lg:h-[80vh] md:h-[576px] h-[383px] flex flex-col items-center justify-center relative cursor-zoom-in">
      <Image
        src={currentSrc}
        alt={data?.attributes?.alternativeText ?? "gallery image"}
        sizes="(max-width: 479px) 500px, 1200px"
        fill
        loading="lazy"
        className={`w-full h-full object-center object-cover transition-all duration-300 ease ${
          loading ? "opacity-50" : "opacity-100"
        }`}
      />
    </div>
  );
};
